import React, {useEffect, useMemo, useState} from "react"
import {getToken, hasExpiredToken, removeToken, setToken} from "./services/Auth/token"
import jwtDecode from "jwt-decode"
import {useNavigate, useLocation} from "react-router-dom";
import AuthContext from "./context/AuthContext"
import {RouteAuth} from "./routes/RouteAuth";
import {RouteAdmin} from "./routes/RouteAdmin";

export default function Home(props) {

    const [auth, setAuth] = useState(undefined)
    const [reloadUser, setReloadUser] = useState(false)
    const navigate = useNavigate()
    const location = useLocation()

    const logout = () => {
        if (auth) {
            removeToken()
            setAuth(null)
            navigate(RouteAuth.LOGIN.path)
        }
    }

    // Mantener los datos del usuario al recargar
    useEffect(() => {
        const token = getToken()
        if (token) {
            if (hasExpiredToken()) {
                navigate(RouteAuth.LOGOUT.path)
            }

            setAuth({
                primaryUser: token.primaryUser,
                secondaryUser: token.secondaryUser
            })
        } else {
            setAuth(null)
            if (!location.pathname.includes(RouteAuth.LOGIN.path)
                && !location.pathname.includes(RouteAuth.SIGNUP.path)
                && !location.pathname.includes(RouteAuth.RECOVER_PASSWORD.path)
                && !location.pathname.includes(RouteAuth.RECOVER_PASSWORD_TOKEN.path)
            ) {
                navigate(RouteAuth.LOGIN.path)
            }
        }

        setReloadUser(false)
    }, [reloadUser])  // eslint-disable-line react-hooks/exhaustive-deps

    // Guardar los datos del usuarios, useMemo evita que vaya recargando si no se modifica algun dato
    // Si backImpersonate = true, significa que dejamos de impersonar para volver a ser role admin
    const login = (token) => {
        if (!token?.backImpersonate) {
            token.primaryUser = {
                token: token.primaryUser,
                idUser: jwtDecode(token.primaryUser).id,
                role: jwtDecode(token.primaryUser).roles[0],
                roleName: nameRole(jwtDecode(token.primaryUser).roles[0]),
                name: jwtDecode(token.primaryUser).name,
                surnames: jwtDecode(token.primaryUser).surnames,
                organizationId: jwtDecode(token.primaryUser).organizationId,
                organizationName: jwtDecode(token.primaryUser).organizationName,
                organizationLogo: jwtDecode(token.primaryUser).organizationLogo,
                verifactuCertificadoFechaExpiracion: jwtDecode(token.primaryUser).verifactuCertificadoFechaExpiracion,
                isSuperAdmin: jwtDecode(token.primaryUser).isSuperAdmin,
            }
        }

        if (token.secondaryUser && token?.initial) {
            token.secondaryUser = {
                token: token.secondaryUser,
                idUser: jwtDecode(token.secondaryUser).id,
                role: jwtDecode(token.secondaryUser).roles[0],
                roleName: nameRole(jwtDecode(token.secondaryUser).roles[0]),
                name: jwtDecode(token.secondaryUser).name,
                surnames: jwtDecode(token.secondaryUser).surnames,
                organizationId: jwtDecode(token.secondaryUser).organizationId,
                organizationName: jwtDecode(token.secondaryUser).organizationName,
                organizationLogo: jwtDecode(token.secondaryUser).organizationLogo,
                verifactuCertificadoFechaExpiracion: jwtDecode(token.secondaryUser).verifactuCertificadoFechaExpiracion,
                isSuperAdmin: jwtDecode(token.secondaryUser).isSuperAdmin,
            }
        }

        // primaryUser
        let primaryUser = token.primaryUser

        // secondaryUser (admin)
        let secondaryUser = token.secondaryUser ?? {}

        let newToken = {
            primaryUser,
            secondaryUser
        }

        setAuth(newToken)
        setToken(newToken)

        if (token.backImpersonate) {
            navigate(RouteAdmin.USER_MANAGEMENT.path)
        }
    }

    const nameRole = (role) => {
        let roleName = ""
        switch (role) {
            case "ROLE_ADMIN":
                roleName = "Administrador"
                break;
            case "ROLE_CLIENT":
                roleName = "Cliente"
                break;
            case "ROLE_WORKER":
                roleName = "Trabajador"
                break;
            default:
                roleName = "Usuario"
        }
        return roleName
    }

    const authData = useMemo(
        () => ({
            auth: auth,
            login: login,
            logout: logout,
            setReloadUser: setReloadUser
        }), [auth]  // eslint-disable-line react-hooks/exhaustive-deps
    )

    if (auth === undefined) {
        return null
    }

    return (
        <AuthContext.Provider value={authData}>
            {props.children}
        </AuthContext.Provider>
    )
}
